export default {"src":"/_next/static/media/funding.4c8dce79.svg","height":50,"width":50};